import apiService from '../../../share/util/api/service';
import resource from '../../../share/util/resourceMap';
import { SAVE_SETTINGS } from './constants';
import { executeSyncRequest } from '../../../share/util/api/syncRequest';

/**
 * カスタマイズ:設定保存
 * @param {object} root 呼び出し元
 * @param {string} systemName システム名
 * @param {object} bodyParam POST時に設定するリクエストBody
 * @returns {Promise<void>} 実行結果
 */
export const saveCustomizeHistories = async (root, systemName, bodyParam) =>
  await executeSyncRequest(
    root,
    // POST API 呼び出しのコールバック
    async () => await apiService.postCall(
      apiService.CST,
      `/netApps/${root.netAppId}/systems/${systemName}/customize/histories`,
      bodyParam
    ),
    // エラー発生のコールバック
    (errorType) => { errorType; root.showUnexpectedError(SAVE_SETTINGS); },
    // POST API レスポンスチェックのコールバック
    // ここでのレスポンスチェックは行わない
    (postApiResponse) => { postApiResponse; return ''; },
    // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
    (result) => { root.validateErrorResult(result, SAVE_SETTINGS); },
  );

/**
 * 設定保存ダイアログ_書き込み設定値の生成
 * @param {object[]} items カスタマイズに表示されているデータリスト
 * @returns {object[]} 設定保存用書き込み設定値map
 */
export const getSaveSettingsRequestBody = (items) => {
  // 現在選択されている値を取得する
  return items.reduce((arr, e) => {
    const set = {
      immutable_id: e.immuTableId,
      updateValue: resource.getCstmSettingValue(e.selectItem, e.mapKeyToValue)
    };
    const targetIndex = arr.findIndex((sys) => sys.system_name === e.systemId);
    if (targetIndex === -1) {
      arr.push({
        system_name: e.systemId,
        setting: [set]
      });
    } else {
      arr[targetIndex].setting.push(set);
    }
    return arr;
  }, []);
};

export default {
  saveCustomizeHistories
};